import React, { useEffect, useRef, useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Toast } from 'primereact/toast';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Layout from '../common/Layout';

const AddScores = () => {

    const { quizId, id } = useParams()
    const isEdit = id ? true : false
    const toast = useRef(null)

    const navigate = useNavigate()

    useEffect(() => {
        isEdit && getQuizScores()
    }, [])

    const schema = yup.object({
        scoreMasterId: yup.string().optional().nullable(), 
        zoneName: yup.string().required("Name is required"),
        zoneDescription: yup.string().required("Description is required"),
        minScore: yup.number().transform((value, originalValue) => (originalValue === "" || isNaN(originalValue)) ? null : value).nullable().required("Min Score is required"),
        maxScore: yup.number().transform((value, originalValue) => (originalValue === "" || isNaN(originalValue)) ? null : value).nullable().required("Max Score is required"),
        type: yup.string().required("Score Type is required"),
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            scoreMasterId: null,
            zoneName: '',
            zoneDescription: '',
            minScore: '',
            maxScore: '',
            isActive: false,
        })
    }

    const getQuizScores = () => {
        ApiHelper.get(`${API_ENDPOINTS.QUIZ_SCORES}/edit/${id}`).then((res) => {
            console.log('res:', res);
            if (res.status === 200) {
                reset({
                    scoreMasterId: res.data.data.scoreMasterId,
                    zoneName: res.data.data.zoneName,
                    zoneDescription: res.data.data.zoneDescription,
                    minScore: res.data.data.minScore,
                    maxScore: res.data.data.maxScore,
                    type: res.data.data.type,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };
    
    const onSubmit = (data) => {
        data.quizId = quizId
        if (data.scoreMasterId) {
            update(data, data.scoreMasterId)
        } else {
            add(data)
        }
    };

    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.QUIZ_SCORES}/${quizId}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate(-1)
                }, 1000)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const update = (data, scoreMasterId) => {
        ApiHelper.put(`${API_ENDPOINTS.QUIZ_SCORES}/edit/${scoreMasterId}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate(-1)
                }, 1000)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

  return (
    <>
        <Toast ref={toast} />
        <Layout>
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                    <div class="d-flex justify-content-between align-items-center py-3">
                        <h4 class="fw-bold py-3 mb-2">
                            <span class="d-flex text-muted fw-light"> 
                                <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate(`/quiz/${quizId}/scores`)}> Manage Results </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                            </span>
                        </h4>
                        <Link to={-1} class="btn btn-secondary">⬅ Go Back</Link>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <div>
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div class="row mb-3">
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Name</label>
                                                    <input type="text" name="zoneName" class="form-control" {...register("zoneName")} />
                                                    <small className="text-danger">{errors.zoneName?.message}</small>
                                                </div>
                                                <div class="col-md-9 mb-3">
                                                    <label class="form-label">Description</label>
                                                    <textarea type="text" name="zoneDescription" class="form-control" {...register("zoneDescription")}></textarea>
                                                    <small className="text-danger">{errors.zoneDescription?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Minmum Score</label>
                                                    <input type="number" name="minScore" onKeyDown={(e) => { if (['e', 'E', '+', '-'].includes(e.key)) { e.preventDefault(); } }} class="form-control" {...register("minScore")} />
                                                    <small className="text-danger">{errors.minScore?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Maximum Score</label>
                                                    <input type="number" name="maxScore" onKeyDown={(e) => { if (['e', 'E', '+', '-'].includes(e.key)) { e.preventDefault(); } }} class="form-control" {...register("maxScore")} />
                                                    <small className="text-danger">{errors.maxScore?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Score Type</label>
                                                    <select id="mySelect" {...register('type')} class="form-select" >
                                                        <option value="">Select Result type</option>
                                                        <option value="red">Red</option>
                                                        <option value="yellow">Yellow</option>
                                                        <option value="green">Green</option>
                                                    </select>
                                                    <small className="text-danger">{errors.type?.message}</small>
                                                </div>
                                                <input type='hidden' {...register("scoreMasterId")}/>
                                            </div>
                                            <div class="mt-4 mb-3">
                                                <button type="submit" class="btn btn-primary me-3">Save</button>
                                                <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                            </div>
                                        </form> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </>
  )
}

export default AddScores
